import clsx from 'clsx';
import * as React from 'react';

export interface Props {
  isOpen: boolean;
  body: React.ReactNode;
  close: () => void;
}

const ModalBody: React.FC<Props> = ({ isOpen, body, close }) =>
  isOpen && (
    <div
      className={clsx(
        'absolute flex w-40 flex-col border-[1px] bg-white text-sm',
        'top-0 right-[100%] rounded-md border-solid border-gray-300 text-gray-800',
        'shadow-[0px_6px_20px_-2px_rgba(26,26,26,0.14),0px_4px_6px_rgba(26,26,26,0.06)]',
      )}
      onMouseUp={() => setTimeout(close, 100)}
    >
      {body}
    </div>
  );

export default ModalBody;
